import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../_metronic/_partials/controls";
import { i18n } from "../../private/languageSelector";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../_redux/customers/customersActions";
function CustomerPointsEditDialog({ show, id, onHide }) {
  const selectedLanguage = localStorage.getItem("language");
  const [isValueChanged, setIsValueChanged] = useState(false);
  const CustomerEditSchema = Yup.object().shape({
    value: Yup.string(),
  });
  const dispatch = useDispatch();
  const { customerForEdit } = useSelector((state) => ({
    customerForEdit: state.customers.customerForEdit,
  }));

  useEffect(() => {
    // server call for getting Customer by id
    if (id) {
      dispatch(actions.fetchCustomer(id));
    }
  }, [id, dispatch]);
  return (
    <div>
      <Modal isOpen={show} className="mx-auto my-auto modal" centered style={{ minWidth: "365px", minHeight: "572px" }}>
        <ModalBody style={{ background: "#FFFFFF", width: "100%", height: "100%", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
          <div>
            <div className={`${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
              <span style={{ color: "#333333", fontSize: "16px", fontWeight: 700 }}>{i18n("Customer.EditPointsBalance")}</span>{" "}
            </div>
            <div className="mt-5">
              <Formik
                enableReinitialize={true}
                initialValues={{ value: customerForEdit?.pointsBalance ? customerForEdit?.pointsBalance : "0.00" }}
                validationSchema={CustomerEditSchema}
                onSubmit={(values) => {
                  dispatch(actions.updateCustomer({ ...customerForEdit, pointsBalance: values?.value })).then(() => {
                    onHide();
                  });
                }}
              >
                {({ handleSubmit, values, setValues, dirty, resetForm }) => {
                  if (dirty) {
                    setIsValueChanged(true);
                  } else {
                    setIsValueChanged(false);
                  }
                  return (
                    <>
                      <div className="form-group pt-1" style={{ marginTop: "2.5rem", textAlign: selectedLanguage === "arabic" ? "right" : "left" }}>
                        <Field name="value" component={Input} placeholder={"Value"} label={"Value"} withFeedbackLabel={true} />
                      </div>
                      <div className="d-flex justify-content-end align-items-center" style={{ gap: "2rem" }}>
                        <div className="cancel-text" onClick={onHide}>
                          {i18n("SubscriptionModals.CANCEL")}
                        </div>
                        <div
                          className={`save-text ${isValueChanged ? "active" : "inactive"} `}
                          style={{ color: isValueChanged ? "#2d9cdb" : "#2D9CDB80", cursor: isValueChanged ? "pointer" : "auto" }}
                          onClick={handleSubmit}
                        >
                          {i18n("UserProfile.SAVE")}
                        </div>
                      </div>
                    </>
                  );
                }}
              </Formik>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CustomerPointsEditDialog;
